import { render, staticRenderFns } from "./GeneralBanner.vue?vue&type=template&id=75fecceb&scoped=true&"
import script from "./GeneralBanner.vue?vue&type=script&lang=js&"
export * from "./GeneralBanner.vue?vue&type=script&lang=js&"
import style0 from "./GeneralBanner.vue?vue&type=style&index=0&id=75fecceb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fecceb",
  null
  
)

export default component.exports